<template>
    <div class="hello">
        <h1>{{ title }}</h1>

        <router-link to="/users" tag="button" v-if="all && showSwitchButton && !loading" type="button">
            <i class="fas fa-random"></i>
            <span class="button-text">Zu den Läufern wechseln</span>
        </router-link>

        <div class="spacer-small"></div>

        <div v-if="loading" class="kgk-loading-indicator"><i class="fas fa-spinner fa-spin"></i></div>
        <div v-else-if="teams">
            <table>
                <thead>
                <tr>
                    <th>&nbsp;</th>
                    <!--<td>Avatar</td>-->
                    <th class="kgk-left">Teamname</th>
                    <th style="white-space:nowrap"># Teilnehmende</th>
                    <th style="white-space:nowrap"># Läufe</th>
                    <th style="white-space:nowrap">&sum; Kilometer</th>
                    <th style="white-space:nowrap">&empty; Kilometer / Läufer*in</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(team, index) in teams"
                    :key="team.identifier">
                    <td>
                        <div v-if="team.team_competitive" class="kgk-mobile-th">Platzierung:</div>
                        <span v-if="team.team_competitive" class="kgk-ranking-num">{{ index + 1 }}.</span>
                    </td>
                    <td class="kgk-left">
                        <div class="kgk-mobile-th">Teamname:</div>
                        {{ team.name }}
                    </td>
                    <td class="kgk-center">
                        <div class="kgk-mobile-th">Anzahl Teammitglieder:</div>
                        {{ team.user_count || 'unknown' }}
                    </td>
                    <td class="kgk-center">
                        <div class="kgk-mobile-th">Anzahl Läufe:</div>
                        {{ team.run_count }}
                    </td>
                    <td class="kgk-center">
                        <div class="kgk-mobile-th">&sum; Kilometer:</div>
                        {{ convertNumberReadable(team.total_length,2) }} km
                    </td>
                    <td class="kgk-center">
                        <div class="kgk-mobile-th">&empty; Kilometer / Läufer*in:</div>
                        <strong>{{ convertNumberReadable(team.user_average_length,2) }} km</strong>
                    </td>
                </tr>
                </tbody>
            </table>

            <router-link to="/teams" tag="button" v-if="!all && !loading" type="button">
                <i class="fas fa-users fa-fw"></i>
                <span class="button-text">Alle Teams anzeigen</span>
            </router-link>
        </div>
        <div v-else-if="error">
            <p>Fehler: {{error}}</p>
        </div>
    </div>
</template>

<script>
    import leaderboard from '../../api/leaderboard';

    export default {
        name: 'LeaderboardTeams',
        props: {
            title: {
                type: String,
                required: false,
                default: 'Topliste Teams',
            },
            all: {
                type: Boolean,
                required: false,
                default: false
            },
            // Wettbewerb.vue embeds this with all=true just to fetch the
            // full team list (not the top-N), not to offer switching over
            // to the standalone /users leaderboard page -- separate from
            // `all` so that page can opt out of just this button.
            showSwitchButton: {
                type: Boolean,
                required: false,
                default: true
            }
        },
        data() {
            return {
                teams: null,
                loading: false,
                error: null,
            }
        },
        mounted() {
            this.loading = true;

            leaderboard.getTeams(
                this,
                this.all,
                data => this.teams = data.teams,
                () => this.error = 'Es ist ein Fehler aufgetreten',
                () => this.loading = false,
            );
        }
    }
</script>

<style scoped>
    /* Both the heading and the buttons below would otherwise inherit
       text-align:left from ancestors that left-align the leaderboard table
       (e.g. Wettbewerb.vue's .kgk-wettbewerb-leaderboard) -- center them
       independent of that. */
    h1 {
        text-align: center;
    }

    button {
        display: block;
        margin-left: auto;
        margin-right: auto;
    }
</style>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<!--<style scoped lang="scss">
    h3 {
        margin: 40px 0 0;
    }
    ul {
        list-style-type: none;
        padding: 0;
    }
    li {
        display: inline-block;
        margin: 0 10px;
    }
    a {
        color: #42b983;
    }
</style>-->
